import React, { useState, useEffect, Fragment, useCallback } from 'react';
import { LocalSettings } from './LocalSettings';
import ParticipantStack from '../containers/ParticipantStack';
import ChatArea from '../containers/ChatArea';
import FormOptionnal from './FormOptional';
import { VideoDeviceInfo, AudioDeviceInfo, DeviceManager, LocalVideoStream } from '@azure/communication-calling';
import { Stack, Spinner } from '@fluentui/react';
import { CloseIcon } from '@fluentui/react-icons-northstar';
import {
  fullHeightStyles,
  paneHeaderStyle,
  settingsContainerStyle,
  paneHeaderTextStyle,
  chatpaneHeaderStyle,
  dropzone,
  dragFiles,
  loadingIcon,
  loadinStyle
} from './styles/CommandPanel.styles';
import { Footer } from './Footer';
import { useDropzone } from 'react-dropzone'
import { createSendFiles } from '../core/chatSideEffects';

export interface CommandPanelProps {
  selectedPane: string;
  videoDeviceInfo: VideoDeviceInfo;
  videoDeviceList: VideoDeviceInfo[];
  audioDeviceList: AudioDeviceInfo[];
  audioDeviceInfo: AudioDeviceInfo;
  setSelectedPane: any;
  setVideoDeviceInfo(device: VideoDeviceInfo): void;
  setAudioDeviceInfo(device: AudioDeviceInfo): void;
  deviceManager: DeviceManager;
  darkColor: string;
  lightColor: string;
  onSendMessage(messageContent: string): void;
  setLocalVideoStream(stream: LocalVideoStream | undefined): void;
}
export enum CommandPanelTypes {
  None = 'none',
  People = 'People',
  Settings = 'Settings',
  Add = 'Additional Information',
  Chat = 'Chat'
}

export const CommandPanel = (props: CommandPanelProps): JSX.Element => {
  const [selectedPane, setSelectedPane] = useState(props.selectedPane);
  const [loader, setLoader] = useState(false);
  const [dynamicCls, setDynamic] = useState(true);
  // console.log(props.darkColor, 'darkColor')
  const [selectedPaneChat, setSelectedPaneChat] = useState(true);
  useEffect(() => {
    setSelectedPane(props.selectedPane);
    if (props.selectedPane !== 'none') {
      setSelectedPaneChat(true);
    }
  }, [props.selectedPane]);

  const onDrop = useCallback(async (acceptedFiles: any) => {
    var newText = '';
    acceptedFiles.forEach((file: any) => {
      const element = file;
      newText += '<p>' + element.name + ' ' + 'Uploaded Successfully, ' + '</p>' + '\n'
    })
    var convertText = newText.replace(/<[^>]+>/g, '');
    // console.log(convertText);
    // const urlParams = new URLSearchParams(window.location.search);
    // const caseNumber = urlParams.get('caseNo');
    setLoader(true);
    const result: any = await createSendFiles(acceptedFiles);
    if (result) {
      const resultData = result.data;
      // console.log(resultData, result.success)
      if (resultData.success && Array.isArray(resultData.data)) {
        if (resultData.data.length > 0) {
          //console.log(result.data)
          resultData.data.forEach((res: any) => {
            // console.log(res)
            props.onSendMessage(res.fileUrl);
            setLoader(false);
          });
        }
      } else {
        setLoader(false);
      }
    }
    // console.log(result, 'result')
  }, [])

  const onSendFiles = async (acceptedFiles: any) => {
    var newText = '';
    acceptedFiles.forEach((file: any) => {
      const element = file;
      newText += '<p>' + element.name + ' ' + 'Uploaded Successfully, ' + '</p>' + '\n'
    })
    var convertText = newText.replace(/<[^>]+>/g, '');
    // console.log(convertText);
    // const urlParams = new URLSearchParams(window.location.search);
    // const caseNumber = urlParams.get('caseNo');
    setLoader(true);
    const result: any = await createSendFiles(acceptedFiles);
    if (result) {
      const resultData = result.data;
      // console.log(resultData, resultData.success)
      if (resultData.success && Array.isArray(resultData.data)) {
        if (resultData.data.length > 0) {
          //console.log(result.data)
          resultData.data.forEach((res: any) => {
            // console.log(res)
            props.onSendMessage(res.fileUrl);
            setLoader(false);
          });
        }
      } else {
        setLoader(false);
      }
    }
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ noClick: true, onDrop })
  // console.log(selectedPane, CommandPanelTypes, 'CommandPanelTypes')
  return (
    <Stack styles={fullHeightStyles} className='mob_chart_bottom_panel'>
      {((selectedPane !== CommandPanelTypes.None) && (selectedPane !== CommandPanelTypes.Chat)) &&
        <Stack.Item className={paneHeaderStyle}>
          <div style={{ width: '100%', background: props.darkColor, height: '45px', borderBottom: '1px solid #ccc', color: '#fff' }}>
            <div style={{ fontSize: '18px', }} className={paneHeaderTextStyle}>
              {selectedPane}
            </div>
            <div style={{ fontSize: '16px', float: 'right', cursor: 'pointer' }} className={paneHeaderTextStyle}>
              <CloseIcon onClick={() => { props.setSelectedPane('Chat') }} />
            </div>
          </div>
        </Stack.Item>
      }
      {selectedPane === CommandPanelTypes.People && (
        <Stack.Item>
          <ParticipantStack />
        </Stack.Item>
      )}
      {selectedPane === CommandPanelTypes.People && (
        <Stack.Item>
          <Footer />
        </Stack.Item>
      )}
      {selectedPane === CommandPanelTypes.Settings && (
        <Stack.Item>
          <div className={settingsContainerStyle} style={{ marginBottom: '15px' }}>
            <LocalSettings
              videoDeviceList={props.videoDeviceList}
              audioDeviceList={props.audioDeviceList}
              audioDeviceInfo={props.audioDeviceInfo}
              videoDeviceInfo={props.videoDeviceInfo}
              setVideoDeviceInfo={props.setVideoDeviceInfo}
              setAudioDeviceInfo={props.setAudioDeviceInfo}
              deviceManager={props.deviceManager}
              setLocalVideoStream={props.setLocalVideoStream}
            />
          </div>
        </Stack.Item>
      )}
      {selectedPane === CommandPanelTypes.Add && (
        <Stack.Item>
          <FormOptionnal darkColor={props.darkColor} />
        </Stack.Item>
      )}
      {/* {(selectedPaneChat && (selectedPane === CommandPanelTypes.None || selectedPane === CommandPanelTypes.Chat || selectedPane === CommandPanelTypes.People || selectedPane === CommandPanelTypes.Settings || selectedPane === CommandPanelTypes.Add)) && ( */}
      {(selectedPaneChat && (selectedPane === CommandPanelTypes.None || selectedPane === CommandPanelTypes.Chat)) && (
        <Fragment>
          <Stack.Item className={chatpaneHeaderStyle}>
            <div style={{ width: '100%', background: props.darkColor, height: '45px', borderBottom: '1px solid #ccc' }}>
              <div style={{ fontSize: '18px' }} className={paneHeaderTextStyle}>{'Chat'}</div>
              <div style={{ fontSize: '16px', float: 'right', cursor: 'pointer' }} className={paneHeaderTextStyle}>
                <CloseIcon onClick={() => { setSelectedPaneChat(false); props.setSelectedPane(selectedPane === 'Chat' ? 'none' : selectedPane); }} />
              </div>
            </div>
          </Stack.Item>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            <Stack.Item className={isDragActive ? dropzone : (loader ? loadingIcon : '')}>
              {isDragActive && <div className={dragFiles}>Drag Files Here</div>}
              {loader && <Spinner label={'Uploading files...'} ariaLive="assertive" labelPosition="top" className={loadinStyle} />}
              <ChatArea
                loader={loader}
                onSendFiles={onSendFiles}
                // dynamicCls={(selectedPane === CommandPanelTypes.People || selectedPane === CommandPanelTypes.Settings || selectedPane === CommandPanelTypes.Add) ? dynamicCls : false}
                dynamicCls={false}
              />
            </Stack.Item>
          </div>
        </Fragment>
      )}
    </Stack>
  );
};
